<template>
    <div v-if="filteredItems.length != 0" class="overview my-3 bg-white rounded border table-responsive">
        <table class="table mb-0">
            <thead class="">
                <tr>
                    <th class="border-top-0 fixed-column"></th>
                    <th class="border-top-0 text-uppercase text-sm tracking-wide font-weight-normal text-muted align-middle text-nowrap fixed-column">Average</th>
                    <th class="border-top-0 text-uppercase text-sm tracking-wide font-weight-normal text-muted align-middle text-nowrap" v-for="(header, index) in dynamicHeaders" :key="index">
                        {{ header }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, key) in staticColumnData" :key="key">
                    <td class="fixed-column text-muted">{{ item }}</td>
                    <td class="fixed-column text-muted">{{ averageData[key] }}</td>
                    <td v-for="(header, index) in dynamicHeaders" :key="index">
                        {{ dynamicData[key][index] }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    computed: {
        dynamicHeaders() {

            return this.filteredItems.map(obj => obj['name']);
        },
        staticColumnData() {
            return {
                'reference': 'Reference',
                'publisher': 'Publisher',
                'publication': 'Publication',
                'type': 'Type',
                'position':'Ad position',
                'formatted_placement_date':'Publication date',
                'agreement':'Agreement',
                'currency_total_price': 'Agreement budget',
                'campaign': 'Campaign',
                'brand': 'Brand',
                'ta': 'TA',
                'currency_cost': 'Ad budget',
                'list_size': 'List size',
                'opens': 'Opens',
                'open_percentage': 'Open %',
                'cost_per_thousand':'CPM(cost per thousand)',
                'internal_clicks': 'Clicks internal',
                'internal_cost_per_click': 'CPC(cost per click) internal',
                'internal_click_through_rate': 'CTR(click  through rate) internal',
                'external_clicks' : 'Clicks publisher',
                'external_cost_per_click': 'CPC(cost per click) publisher',
                'external_click_through_rate': 'CTR(click through rate) publisher',
            };
        },
        dynamicData() {
            let properties = {};
            const relations = ['agreement', 'campaign', 'publisher', 'publication', 'ta', 'brand', 'type'];

            this.filteredItems.forEach(item => {
                Object.keys(item).forEach(key => {
                    if (!properties[key]) {
                        properties[key] = [];
                    }

                    if(key == 'agreement') {
                        if (!properties['currency_total_price']) {
                            properties['currency_total_price'] = [];
                        }

                        properties['currency_total_price'].push(item[key].currency_total_price);
                    }

                    if(relations.includes(key)) {
                        properties[key].push(item[key].name);

                        return;
                    }

                    properties[key].push(item[key]);
                });
            });

            return properties;
        },
        averageData() {
            let properties = {};
            const averages = ['cost', 'list_size', 'opens', 'open_percentage', 'cost_per_thousand', 'internal_clicks', 'internal_cost_per_click', 'internal_click_through_rate', 'external_clicks', 'external_cost_per_click', 'external_click_through_rate'];
            const withEuro = ['cost', 'cost_per_thousand', 'internal_cost_per_click', 'external_cost_per_click'];
            const withPercentage = ['open_percentage', 'internal_click_through_rate', 'external_click_through_rate'];

            Object.keys(this.dynamicData).forEach(key => {
                if(averages.includes(key)) {
                    const items = this.dynamicData[key];
                    let average = (items.reduce((total, next) => total + parseFloat(String(next).replace(/[^0-9.,]/g, "").trim().replace(',', '.')|| 0) , 0) / items.length).toFixed(2);

                    if(withEuro.includes(key)) {
                        average = '€ ' + average;
                    }

                    if(withPercentage.includes(key)) {
                        average = average +  ' %';
                    }

                    properties[key] = String(average).replace('.',',');

                    return;
                }
            });

            return properties;
        },
    },
    props: {
        filteredItems: { type: Array, required:true },
    },
}
</script>